module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "m-b-5 ovf-hd"
  }, [_c('div', {
    staticClass: "fl w-400"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入凭证编号/关联人/发票代码/发票号码",
      "clearable": ""
    },
    model: {
      value: (_vm.keywords),
      callback: function($$v) {
        _vm.keywords = $$v
      },
      expression: "keywords"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        return _vm.search()
      }
    },
    slot: "append"
  })], 1)], 1)]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "height": _vm.setHeight.page_height,
      "border": ""
    },
    on: {
      "selection-change": _vm.selectItem
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "document_number",
      "label": "凭证编号",
      "width": "180",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "档案管理企业",
      "width": "120",
      "show-overflow-tooltip": true
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [(scope.row.company_name == null) ? _c('span', [_vm._v("个人")]) : _c('span', [_vm._v(_vm._s(scope.row.company_name))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user_name",
      "label": "凭证关联人",
      "width": "120",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "code",
      "label": "发票代码",
      "width": "180",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "number",
      "label": "发票号码",
      "width": "150",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "day",
      "label": "开票日期",
      "width": "120",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "no_tax_money",
      "label": "不含税金额",
      "width": "200",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tax_money",
      "label": "税额",
      "width": "200",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "money",
      "label": "价税合计金额",
      "width": "200",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "unit",
      "label": "销售方",
      "width": "200",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "project",
      "label": "项目名称",
      "width": "200",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "width": "180",
      "label": "导入时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [(scope.row.status == 1) ? _c('span', {
          staticStyle: {
            "color": "#0c0"
          }
        }, [_vm._v("正常")]) : (scope.row.status == 0) ? _c('span', {
          staticStyle: {
            "color": "#bb0"
          }
        }, [_vm._v(_vm._s(_vm._f("status")(scope.row.status)))]) : (scope.row.status == -1) ? _c('span', {
          staticStyle: {
            "color": "#d00"
          }
        }, [_vm._v(_vm._s(_vm._f("status")(scope.row.status)))]) : _vm._e()])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "验真状态",
      "show-overflow-tooltip": true,
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [(scope.row.is_really == 1) ? _c('span', {
          staticClass: "success_status"
        }, [_vm._v("验真成功")]) : (scope.row.is_really == 0) ? _c('span', [_vm._v("未验真")]) : (scope.row.is_really == -1) ? _c('span', {
          staticClass: "error_status"
        }, [_vm._v("验真失败")]) : _vm._e()])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "报销状态",
      "show-overflow-tooltip": true,
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [(scope.row.bill_status >= 1 && scope.row.bill_status <= 6 && scope.row.bill_status != 4) ? _c('span', {
          staticClass: "goon_status"
        }, [_vm._v("报销中")]) : (scope.row.bill_status == 4) ? _c('span', {
          staticClass: "error_status"
        }, [_vm._v("驳回")]) : (scope.row.bill_status == 0) ? _c('span', {
          staticClass: "goon_status"
        }, [_vm._v("待提交")]) : (scope.row.bill_status == 7) ? _c('span', {
          staticClass: "success_status"
        }, [_vm._v("已报销")]) : (scope.row.bill_status == -1) ? _c('span', [_vm._v("未报销")]) : _vm._e()])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "文件预览",
      "fixed": "right",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [(scope.row.img_type == 2) ? _c('el-button', {
          attrs: {
            "type": "success",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.ofd_detail = [];
              _vm.ofd_detail = scope.row;
              _vm.look_ofd_file = true
            }
          }
        }, [_vm._v("预览文件")]) : _vm._e(), _vm._v(" "), (scope.row.img_type != 2) ? _c('el-button', {
          attrs: {
            "type": "success",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.img_detail = [];
              _vm.img_detail = scope.row;
              _vm.look_img_file = true
            }
          }
        }, [_vm._v("预览文件")]) : _vm._e()], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('el-drawer', {
    attrs: {
      "title": "详情",
      "visible": _vm.dialogVisible,
      "direction": _vm.direction
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', [_vm._v("\n      档案管理企业："), _c('span', [_c('b', {
    domProps: {
      "textContent": _vm._s(_vm.detail.company_name ? _vm.detail.company_name : '无')
    }
  })])]), _vm._v(" "), _c('div', [_vm._v("\n      凭证关联人："), _c('span', [_c('b', [_vm._v(_vm._s(_vm.detail.user_name))])])]), _vm._v(" "), _c('div', [_vm._v("\n      发票代码："), _c('span', [_c('b', [_vm._v(_vm._s(_vm.detail.code))])])]), _vm._v(" "), _c('div', [_vm._v("\n      发票号码："), _c('span', [_c('b', [_vm._v(_vm._s(_vm.detail.number))])])]), _vm._v(" "), _c('div', [_vm._v("\n      开票日期："), _c('span', [_c('b', [_vm._v(_vm._s(_vm.detail.day))])])]), _vm._v(" "), _c('div', [_vm._v("\n      往来单位："), _c('span', [_c('b', [_vm._v(_vm._s(_vm.detail.unit))])])]), _vm._v(" "), _c('div', [_vm._v("\n      不含税金额："), _c('span', [_c('b', [_vm._v(_vm._s(_vm.detail.no_tax_money))]), _vm._v(" 元")])]), _vm._v(" "), _c('div', [_vm._v("\n      税额："), _c('span', [_c('b', [_vm._v(_vm._s(_vm.detail.tax_money))]), _vm._v(" 元")])]), _vm._v(" "), _c('div', [_vm._v("\n      价税合计金额："), _c('span', [_c('b', [_vm._v(_vm._s(_vm.detail.money))]), _vm._v(" 元")])]), _vm._v(" "), _c('div', [_vm._v("\n      凭证编号："), _c('span', [_c('b', [_vm._v(_vm._s(_vm.detail.document_number))])])]), _vm._v(" "), _c('div', [_vm._v("\n      导入时间："), _c('span', [_c('b', [_vm._v(_vm._s(_vm.detail.create_time))])])]), _vm._v(" "), _c('div', [_vm._v("\n      发票：\n        "), (_vm.detail.img_type == 1) ? _c('el-popover', {
    attrs: {
      "placement": "left-end",
      "width": "400",
      "trigger": "click"
    }
  }, [_c('object', {
    attrs: {
      "data": _vm.detail.url,
      "type": "application/pdf",
      "width": "100%"
    }
  }), _vm._v(" "), _c('object', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "slot": "reference",
      "data": _vm.detail.url,
      "type": "application/pdf",
      "width": "100",
      "height": "100"
    },
    slot: "reference"
  })]) : _vm._e(), _vm._v(" "), (_vm.detail.img_type == 3) ? _c('el-popover', {
    attrs: {
      "placement": "left-end",
      "width": "400",
      "trigger": "click"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.detail.url,
      "width": "100%"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "m-r-10",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "slot": "reference",
      "src": _vm.detail.url,
      "width": "100",
      "height": "100"
    },
    slot: "reference"
  })]) : _vm._e(), _vm._v(" "), (_vm.detail.img_type == 2) ? _c('span', [_vm._v("ofd文件，暂不支持查看")]) : _vm._e()], 1), _vm._v(" "), _c('div', [_vm._v("\n      附件：\n        "), _vm._l((_vm.detail.enclosure), function(item) {
    return _c('el-popover', {
      attrs: {
        "placement": "right-end",
        "width": "400",
        "trigger": "click"
      }
    }, [_c('img', {
      attrs: {
        "src": item,
        "width": "100%"
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "m-r-10",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "slot": "reference",
        "src": item,
        "width": "100",
        "height": "100"
      },
      slot: "reference"
    })])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "pos-rel p-t-20"
  }, [_c('div', {
    staticClass: "block pages"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.limit,
      "current-page": _vm.currentPage,
      "total": _vm.dataCount
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "",
      "visible": _vm.look_ofd_file,
      "append-to-body": "",
      "close-on-click-modal": true,
      "show-close": false,
      "custom-class": "w-800"
    },
    on: {
      "update:visible": function($event) {
        _vm.look_ofd_file = $event
      }
    }
  }, [_c('ofdGroup', {
    attrs: {
      "ofd_detail": _vm.ofd_detail
    },
    on: {
      "closeMain": function($event) {
        _vm.look_ofd_file = false;
      }
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "",
      "visible": _vm.look_img_file,
      "append-to-body": "",
      "close-on-click-modal": true,
      "show-close": false,
      "custom-class": "w-800"
    },
    on: {
      "update:visible": function($event) {
        _vm.look_img_file = $event
      }
    }
  }, [_c('imgGroup', {
    attrs: {
      "img_detail": _vm.img_detail
    },
    on: {
      "closeMain": function($event) {
        _vm.look_img_file = false;
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3d822cf3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Appistrative/company/invoice/list.vue
// module id = 1832
// module chunks = 2